import { type VariantProps, cva } from 'class-variance-authority';
import * as React from 'react';

import { cn } from '../../utils';

const counterVariants = cva(
  'inline-flex items-center justify-center rounded-full font-semibold self-center',
  {
    variants: {
      variant: {
        default: 'bg-surface text-contrast',
        success: 'bg-success/10 text-success',
        warning: 'bg-warning/10 text-warning',
        critical: 'bg-critical/10 text-critical',
      },
      size: {
        small: 'size-4 text-[0.625rem]',
        medium: 'size-5 text-[0.75rem]',
        big: 'size-7 text-[0.75rem]',
        large: 'size-10 text-[0.75rem]',
        huge: 'size-18 text-[0.75rem]',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'small',
    },
  },
);

export interface CounterProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof counterVariants> {}

function Counter({ className, variant, size, ...props }: CounterProps) {
  return <div className={cn(counterVariants({ variant, size }), className)} {...props} />;
}

export { counterVariants, Counter };
